var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section", class: _vm.input.extraClass }, [
    _c(
      "span",
      { staticClass: "headline" },
      [
        _vm._v("\n     " + _vm._s(_vm.input.label) + "\n         "),
        _vm.input.helper
          ? [
              _c("div", { staticClass: "helper" }, [
                _c("img", { attrs: { src: "/images/icon.questionmark.svg" } }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.input.helper))]),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inner grid-50w", class: _vm.input.grid },
      [
        _vm._l(_vm.input.forms, function (sectionInput) {
          return [
            sectionInput.type === "section"
              ? [
                  _c("Section", {
                    attrs: { input: sectionInput, formValue: _vm.formValue },
                  }),
                ]
              : [
                  _c("InputField", {
                    attrs: { input: sectionInput, formValue: _vm.formValue },
                  }),
                ],
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }